export const DIFFICULTY = Object.freeze({
  STANDARD: "standard",
  HARD: "hard",
  EXTREME: "extreme"
});

export const BALL_SPEED_PRESET = Object.freeze({
  SLOW: "slow",
  NORMAL: "normal",
  FAST: "fast"
});

export const DEFAULT_GAME_SETTINGS = Object.freeze({
  version: 1,
  difficulty: DIFFICULTY.STANDARD,
  soundEnabled: true,
  ballSpeedPreset: BALL_SPEED_PRESET.NORMAL
});

const DIFFICULTY_TUNING = Object.freeze({
  // 正面道具：难度越高越少；炸弹：难度越高越多。
  [DIFFICULTY.STANDARD]: Object.freeze({
    propDropMultiplier: 1,
    bombDropMultiplier: 1
  }),
  [DIFFICULTY.HARD]: Object.freeze({
    propDropMultiplier: 0.65,
    bombDropMultiplier: 1.5
  }),
  [DIFFICULTY.EXTREME]: Object.freeze({
    propDropMultiplier: 0.35,
    bombDropMultiplier: 2
  })
});

const BALL_SPEED_VALUES = Object.freeze({
  [BALL_SPEED_PRESET.SLOW]: 2.0,
  [BALL_SPEED_PRESET.NORMAL]: 2.6,
  [BALL_SPEED_PRESET.FAST]: 3.5
});

function isOneOf(value, values) {
  return values.includes(value);
}

export function normalizeSettings(value) {
  const source = value && typeof value === "object" ? value : {};
  return {
    version: 1,
    difficulty: isOneOf(source.difficulty, Object.values(DIFFICULTY))
      ? source.difficulty
      : DEFAULT_GAME_SETTINGS.difficulty,
    soundEnabled: typeof source.soundEnabled === "boolean"
      ? source.soundEnabled
      : DEFAULT_GAME_SETTINGS.soundEnabled,
    ballSpeedPreset: isOneOf(source.ballSpeedPreset, Object.values(BALL_SPEED_PRESET))
      ? source.ballSpeedPreset
      : DEFAULT_GAME_SETTINGS.ballSpeedPreset
  };
}



export function getGameplayTuning(settings) {
  const normalized = normalizeSettings(settings);
  return {
    difficulty: normalized.difficulty,
    soundEnabled: normalized.soundEnabled,
    ballSpeed: BALL_SPEED_VALUES[normalized.ballSpeedPreset],
    ballSpeedPreset: normalized.ballSpeedPreset,
    propDropMultiplier: DIFFICULTY_TUNING[normalized.difficulty].propDropMultiplier,
    bombDropMultiplier: DIFFICULTY_TUNING[normalized.difficulty].bombDropMultiplier
  };
}
